export default __webpack_public_path__ + "static/media/our-story-tv.8ccd6ef3.gif";